/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompanyOverviewDto
 */
export interface CompanyOverviewDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyOverviewDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyOverviewDto
     */
    name: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyOverviewDto
     */
    totalOrderCount: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyOverviewDto
     */
    totalOrderAmount: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyOverviewDto
     */
    fullAddress: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyOverviewDto
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyOverviewDto
     */
    number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyOverviewDto
     */
    addition?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyOverviewDto
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyOverviewDto
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyOverviewDto
     */
    country?: string | null;
}

/**
 * Check if a given object implements the CompanyOverviewDto interface.
 */
export function instanceOfCompanyOverviewDto(value: object): value is CompanyOverviewDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('totalOrderCount' in value) || value['totalOrderCount'] === undefined) return false;
    if (!('totalOrderAmount' in value) || value['totalOrderAmount'] === undefined) return false;
    if (!('fullAddress' in value) || value['fullAddress'] === undefined) return false;
    return true;
}

export function CompanyOverviewDtoFromJSON(json: any): CompanyOverviewDto {
    return CompanyOverviewDtoFromJSONTyped(json, false);
}

export function CompanyOverviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyOverviewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'totalOrderCount': json['totalOrderCount'],
        'totalOrderAmount': json['totalOrderAmount'],
        'fullAddress': json['fullAddress'],
        'street': json['street'] == null ? undefined : json['street'],
        'number': json['number'] == null ? undefined : json['number'],
        'addition': json['addition'] == null ? undefined : json['addition'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}

export function CompanyOverviewDtoToJSON(json: any): CompanyOverviewDto {
    return CompanyOverviewDtoToJSONTyped(json, false);
}

export function CompanyOverviewDtoToJSONTyped(value?: CompanyOverviewDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'totalOrderCount': value['totalOrderCount'],
        'totalOrderAmount': value['totalOrderAmount'],
        'fullAddress': value['fullAddress'],
        'street': value['street'],
        'number': value['number'],
        'addition': value['addition'],
        'postalCode': value['postalCode'],
        'city': value['city'],
        'country': value['country'],
    };
}

